import plangridTrackEvents from "./amplitudeInit-vanilla";
import getPageNameFromLocation from "../../pages/helpers/getPageNameFromLocation";

const init = () => {
  const pageName = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pageName);

  const featureButton = document.querySelector("[data-page-element='featureCTA']");

  featureButton.addEventListener('click', () => {
    document.getElementById('survey').scrollIntoView(false);
  });
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/feature.js